// pages/LoginPage.jsx

import { useState } from "react";
import { useNavigate } from "react-router-dom"; // ✅ add this
import Logo from "../shared/components/Logo";

const LOGIN_URL = `${process.env.REACT_APP_API_BASE_URL}/login`; // 🔁 Replace with your actual endpoint

const LoginPage = ({ onLogin }) => {
  const navigate = useNavigate(); // ✅ add this line
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async () => {
    setError("");

    if (!email || !password) return setError("Please enter both email and password.");
    if (!email.includes("@")) return setError("Please enter a valid email address.");
    if (password.length < 4)  return setError("Password must be at least 4 characters.");

    setLoading(true);

    try {
      const response = await fetch(LOGIN_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!response.ok || data.code !== 200) {
        setError(data.message || "Login failed. Please try again.");
        return;
      }

      // Store token & user in localStorage for later use
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));

      onLogin(data.user);
       navigate("/dashboard");

    } catch (err) {
      setError("Network error. Please check your connection and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <Logo />

        <div className="login-heading">Welcome back</div>
        <div className="login-subtext">Sign in to your account to continue</div>

        {error && <div className="error-box">{error}</div>}

        <label className="form-label">Email</label>
        <input
          className="form-input"
          type="email"
          placeholder="you@company.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
        />

        <label className="form-label">Password</label>
        <input
          className="form-input"
          type="password"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
        />

        <button
          className="btn-primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Signing in..." : "Sign In →"}
        </button>
      </div>
    </div>
  );
};

export default LoginPage;